import React from "react";
import {
  Wrapper,
  Container,
  Header,
  Title,
  Line,
  IconContainer,
} from "./styled";
import EnlargeGrayIcon from "../../Icons/EnlargeIcon/gray";

const LittleModal = (props) => {
  return (
    <Wrapper>
      <Container>
        <Header>
          <IconContainer onClick={props.toggle}>
            <EnlargeGrayIcon />
          </IconContainer>
          <Title>{props.title}</Title>
          <Line />
        </Header>
        {props.children}
      </Container>
    </Wrapper>
  );
};

export default LittleModal;
